import { Button } from "@progress/kendo-react-buttons";
import { ICON_BASE_PATH } from "@/app/utils/config";
import Spinner from "../loader/ButtonSpinner";
import type { ReactNode } from "react";


interface GxApplyMdButtonProps {
  label?: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  loadingLabel?: string;
}

const GxViewInvoiceButton: React.FC<GxApplyMdButtonProps> = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  loadingLabel,
}) => {

  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      className="gx-drawer-save-button-md gx-submit-for-approval-small"
    >
      {loading ? (
        <Spinner />
      ) : (
        <img
            src={`${ICON_BASE_PATH}proicons_eye.svg`}
            alt="toggle visibility"
            className="gx-viewinvoice-button-eye-img"
          />
      )}
      <span className="gx-p12-eb">{getButtonText()}</span>
    </Button>
  );
};
export default GxViewInvoiceButton;
